<template>
  <div class="details module">
    <NavBar></NavBar>
    <div class="title-block">
      <button class="return" onclick="history.back()">
        <v-icon>mdi-keyboard-return</v-icon>
      </button>
      <h1 class="text-h2 my-8 text-center">Détails du Module</h1>
    </div>
    <div class="mx-16 pb-10 pl-16">
      <v-card class="data-table">
        <v-card-title
          class="title-details rounded-lg text-center d-flex justify-center"
        >
          Informations
        </v-card-title>
        <div class="d-flex flex-row align-start background-details flex-wrap">
          <v-list class="details-content d-flex flex-wrap pt-0 pb-8 w-100">
            <v-list-item class="w-100 pa-0" v-for="key in keyOrder1" :key="key">
              <div class="details-table-infos px-10 py-3">
                <div class="details-table-infos__cell">
                  <div :class="{ 'text-primary': key === 'SubThemes' }">
                    <strong>{{ keyTextMap[key] }} :</strong>
                  </div>
                  <div class="details-table-infos-content">
                    <div v-if="key === 'SubThemes'">
                      {{ module.SubThemes }}
                    </div>
                    <template v-else>
                      {{ module[key] }}
                    </template>
                  </div>
                </div>

                <div
                  v-if="key !== 'SubThemes'"
                  class="details-table-infos__edit"
                  @click="openUpdateDialog(key)"
                >
                  <v-icon icon="mdi-pencil" size="x-large"></v-icon>
                </div>
              </div>
            </v-list-item>

            <div class="w-100">
              <h2 class="px-10 mt-6 text-h6 font-weight-bold">
                Commentaires :
                <v-btn icon class="ml-2" @click="openAddCommentDialog">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </h2>

              <div class="comments-list px-10 mt-4 d-flex">
                <v-card
                  v-for="comment in reversedComments"
                  :key="comment.ID_FS_CommentsModule"
                  class="comment-block pa-2 mb-4 rounded-lg"
                  color="secondary"
                >
                  <div class="comment-header d-flex justify-between">
                    <h3 class="comment-date mb-2 d-flex">
                      <span class="comment-date__user">
                        {{ comment.ID_NDAppUser }}
                      </span>
                      &nbsp;-&nbsp;
                      <span class="comment-date__date">
                        {{ formatDate(comment.DAT_Created) }}
                      </span>
                    </h3>
                    <div class="comment-actions">
                      <div
                        class="comment-edit"
                        @click="openCommentUpdateDialog(comment)"
                      >
                        <v-icon icon="mdi-pencil" size="x-large"></v-icon>
                      </div>
                      <div
                        class="comment-delete"
                        @click="openDeleteDialog(comment)"
                      >
                        <v-icon icon="mdi-delete" size="x-large"></v-icon>
                      </div>
                    </div>
                  </div>

                  <p class="comment-text">{{ comment.TXT_Comment }}</p>
                </v-card>
              </div>
            </div>

            <div class="px-10 py-3 mt-8 d-flex align-center">
              <h2 class="text-h6 font-weight-bold">Questions associées :</h2>
              <v-btn
                icon
                class="details-table-infos__edit ml-2"
                @click="openUpdateDialog('Questions')"
              >
                <v-icon icon="mdi-pencil" size="x-large"></v-icon>
              </v-btn>
            </div>

            <v-data-table
              :headers="QuestionsHeaders"
              :items="module.Questions"
              class="w-100 related-data-table mx-10"
              color="table"
            >
              <template v-slot:[`item.TXT_Question`]="{ item }">
                <router-link :to="`/questions/${item.ID_D_Question}`">{{
                  item.TXT_Question
                }}</router-link>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <div class="question-actions">
                  <v-btn
                    icon
                    variant="text"
                    density="comfortable"
                    class="question-actions__unassign"
                    @click="openUnassignQuestionDialog(item)"
                  >
                    <v-icon>mdi-link-off</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Désaffecter du module
                    </v-tooltip>
                  </v-btn>

                  <v-btn
                    icon
                    variant="text"
                    density="comfortable"
                    color="error"
                    class="question-actions__delete"
                    @click="openQuestionDeleteDialog(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Supprimer la question
                    </v-tooltip>
                  </v-btn>
                </div>
              </template>
            </v-data-table>

            <div
              class="d-flex w-100 mt-6 px-10 align-center justify-space-between"
            >
              <div class="details-dates d-flex">
                <div
                  class="w-100 pa-0 details-dates__element"
                  v-for="key in keyOrder2"
                  :key="key"
                >
                  <div class="element">
                    <div>
                      <strong>{{ keyTextMap[key] }} :</strong>
                    </div>
                    <div>
                      <!-- Utilisation de la méthode formatDate si la clé est une date -->
                      {{
                        key === "DAT_LastEdited" || key === "DAT_Created"
                          ? formatDate(module[key])
                          : module[key]
                      }}
                    </div>
                  </div>
                </div>
              </div>

              <v-btn color="primary" @click="openDeleteModuleDialog(module)"
                >Supprimer le module</v-btn
              >
            </div>
          </v-list>
        </div>
      </v-card>
    </div>

    <v-dialog
      v-if="fieldToUpdate === 'Questions'"
      v-model="dialog"
      transition="dialog-top-transition"
      persistent
      min-width="800"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="search"
            clearable
            prepend-inner-icon="mdi-magnify"
            label="Rechercher..."
            single-line
            hide-details
            @keyup.enter="getQuestions(true)"
            @click:prepend-inner="getQuestions(true)"
            @click:clear="resetSearch"
            density="compact"
            bg-color="grey-darken-3"
            color="primary"
          ></v-text-field>
          <v-data-table-server
            :show-current-page="true"
            :headers="DialogQuestionsHeaders"
            v-model:page="currentPage"
            :items="Popupquestions"
            :items-length="totalQuestions"
            items-per-page-text="Nombre d'élements par page."
            :loading="isLoading"
            no-data-text="Aucune donnée"
            @update:options="updateOptions"
            item-key="ID_D_Question"
            density="compact"
          >
            <template v-slot:[`item.selected`]="{ item }">
              <v-checkbox
                class="d-flex justify-center ma-0 pa-0"
                v-model="item.selected"
                @change="updateSelectedItems(item)"
                density="compact"
              ></v-checkbox>
            </template>
          </v-data-table-server>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Annuler</v-btn>
          <v-btn
            color="primary"
            text
            @click="confirmUpdate"
            :loading="isUpdating"
            :disabled="isUpdating"
          >
            Valider
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="fieldToUpdate !== 'Questions'"
      v-model="dialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      min-width="800"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
        <v-card-text>
          <v-textarea
            v-if="
              fieldToUpdate !== 'SubThemes' &&
              fieldToUpdate !== 'Questions' &&
              fieldToUpdate !== 'TXT_Description' &&
              fieldToUpdate !== 'TXT_LearningObjectif'
            "
            rows="1"
            auto-grow
            variant="underlined"
            v-model="newFieldValue"
            :rules="[rules.required]"
            color="primary"
          ></v-textarea>
          <v-textarea
            v-else-if="
              fieldToUpdate === 'TXT_Description' ||
              fieldToUpdate === 'TXT_LearningObjectif'
            "
            rows="1"
            auto-grow
            variant="underlined"
            v-model="newFieldValue"
            color="primary"
          ></v-textarea>
        </v-card-text>

        <v-card-actions v-if="fieldToUpdate !== 'Questions'">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Annuler</v-btn>
          <v-btn color="primary" text @click="confirmUpdate">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addCommentDialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      min-width="400"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline">Ajouter un commentaire</v-card-title>
        <v-card-text>
          <v-textarea
            rows="1"
            auto-grow
            variant="underlined"
            v-model="newComment"
            :rules="[rules.required]"
            color="primary"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="addCommentDialog = false"
            >Annuler</v-btn
          >
          <v-btn color="primary" text @click="addComment">Ajouter</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="unassignQuestionDialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      min-width="400"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline">Désaffecter la question</v-card-title>
        <v-card-text>
          <div>Retirer cette question du module ?</div>
          <div class="my-3">
            <strong>{{ questionToUnassign?.TXT_Question }}</strong>
          </div>
          <div>Elle reste disponible et pourra être réaffectée.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="isUnassigning"
            @click="unassignQuestionDialog = false"
            >Annuler</v-btn
          >
          <v-btn
            color="primary"
            text
            :loading="isUnassigning"
            @click="unassignQuestionFromModule"
            >Désaffecter</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteQuestionDialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      min-width="400"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline">Supprimer la question</v-card-title>
        <v-card-text>
          <div>Supprimer définitivement la question suivante ?</div>
          <div class="my-3">
            <strong>{{ questionToDelete?.TXT_Question }}</strong>
          </div>
          <div>
            Elle disparaîtra de toute l'application, y compris des autres
            modules où elle pourrait être utilisée.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="isDeletingQuestion"
            @click="deleteQuestionDialog = false"
            >Annuler</v-btn
          >
          <v-btn
            color="error"
            text
            :loading="isDeletingQuestion"
            @click="deleteQuestion"
            >Supprimer</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      min-width="400"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline">Supprimer le commentaire</v-card-title>
        <v-card-text
          >Voulez-vous vraiment supprimer ce commentaire ?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false"
            >Annuler</v-btn
          >
          <v-btn color="primary" text @click="deleteComment">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteModuleDialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      min-width="400"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline"
          >Êtes-vous sûr de vouloir supprimer ce module ?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteModuleDialog = false"
            >Annuler</v-btn
          >
          <v-btn color="primary" text @click="deleteModule">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000">
      <p v-html="snackbarMessage"></p>
    </v-snackbar>
    <FooterBar></FooterBar>

  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import authExpirationMixin from "@/mixins/isLogged.js";
import axios from "axios";
import {
  base_url,
  modules_urls,
  comments_urls,
  user_urls,
  questions_urls,
  header,
} from "@/API/config.js";
import FooterBar from "@/components/Footer.vue";
import { unassignQuestionFromModuleUseCase } from "@/API/services/module";
import { deleteQuestionUseCase } from "@/API/services/questions";

export default {
  mixins: [authExpirationMixin],
  name: "ModuleSlug",
  components: {
    FooterBar,
    NavBar,
  },
  data() {
    return {
      selectedItems: new Set(),
      module: {
        comments: [],
      },
      keyTextMap: {
        TXT_Module: "Module",
        TXT_Description: "Description",
        TXT_LearningObjectif: "Objectif pédagogique",
        TXT_Ref: "Ref",
        DAT_Created: "Création",
        TXT_LastEditedBy: "Modifié par",
        DAT_LastEdited: "Dernière modification",
        SubThemes: "Sous-Thème associé",
        Questions: "Questions associées",
      },
      keyOrder1: [
        "TXT_Module",
        "TXT_Description",
        "TXT_LearningObjectif",
        "TXT_Ref",
        "SubThemes",
      ],
      keyOrder2: ["DAT_Created", "DAT_LastEdited", "TXT_LastEditedBy"],

      QuestionsHeaders: [
        {
          title: "Questions",
          value: "TXT_Question",
          key: "TXT_Question",
        },
        {
          title: "Actions",
          value: "actions",
          key: "actions",
          sortable: false,
          align: "start",
          width: "120px",
        },
        // {
        //   title: "Bonne réponse",
        //   value: "TXT_RightAnswer",
        //   key: "TXT_RightAnswer",
        // },
      ],

      DialogQuestionsHeaders: [
        {
          title: "Sélectionner",
          value: "selected",
          key: "selected",
          sortable: false,
          width: "100px",
        },
        {
          title: "Question",
          value: "TXT_Question",
          key: "TXT_Question",
          sortable: false,
        },
        {
          title: "Bonne Réponse",
          value: "TXT_RightAnswer",
          key: "TXT_RightAnswer",
          sortable: false,
        },
        {
          title: "Mauvaise Réponse 1",
          value: "TXT_WrongAnswer1",
          key: "TXT_WrongAnswer1",
          sortable: false,
        },
        {
          title: "Mauvaise Réponse 2",
          value: "TXT_WrongAnswer2",
          key: "TXT_WrongAnswer2",
          sortable: false,
        },
        {
          title: "Explications",
          value: "TXT_Explication",
          key: "TXT_Explication",
          sortable: false,
        },
      ],

      totalQuestions: 0,
      currentPage: 1,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      selectedQuestions: [],
      cacheVersion: null,
      Popupquestions: [],

      dialog: false,
      dialogTitle: "",
      newFieldValue: "",
      fieldToUpdate: null,
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",

      currentCommentID: null,
      addCommentDialog: false,
      newComment: "",
      deleteDialog: false,
      commentToDelete: null,
      unassignQuestionDialog: false,
      questionToUnassign: null,
      isUnassigning: false,
      questionToDelete: null,
      deleteQuestionDialog: false,
      isDeletingQuestion: false,
      moduleToDelete: null,
      deleteModuleDialog: false,

      SubThemes: [],
      Questions: [],
      search: "",
      isLoading: false,
      isUpdating: false,

      rules: {
        required: (value) => !!value || "Ce champ est requis.",
      },
    };
  },

  watch: {
    dialog(newVal) {
      if (newVal && this.fieldToUpdate === "Questions") {
        this.getQuestions();
      }
    },
    Popupquestions: {
      handler(newItems) {
        newItems.forEach((item) => {
          if (item.selected) {
            this.selectedItems.add(item.ID_D_Question);
          } else {
            this.selectedItems.delete(item.ID_D_Question);
          }
        });
      },
      deep: true,
    },
    options: {
      handler() {
        this.getQuestions();
      },
      deep: true,
    },
  },

  methods: {
    async initializeCacheBusting() {
      const cacheVersionKeys = Object.keys(localStorage).filter((key) =>
        key.startsWith("cacheVersion")
      );

      if (cacheVersionKeys.length > 0) {
        const latestCacheVersion = cacheVersionKeys.reduce((latest, key) => {
          const version = parseInt(localStorage.getItem(key));
          return version > latest ? version : latest;
        }, 0);

        return latestCacheVersion.toString();
      } else {
        const response = await axios.get(
          `${base_url}${questions_urls.get_all}`,
          header
        );
        const cacheVersion = response.data.results.cache_version;
        localStorage.setItem("cacheVersion", cacheVersion);
        return cacheVersion;
      }
    },

    updateCacheBusting(newCacheVersion) {
      localStorage.setItem(`cacheVersion_${newCacheVersion}`, newCacheVersion);
    },

    async getQuestions(resetPage = false) {
      if (resetPage) {
        this.currentPage = 1;
        this.options.page = 1;
      }

      this.isLoading = true;
      const cacheVersion = await this.initializeCacheBusting();
      const { itemsPerPage, page } = this.options;
      let url = `${base_url}${questions_urls.get_all}?page=${page}&page_size=${itemsPerPage}&cacheVersion=${cacheVersion}`;
      if (this.search) {
        url += `&query=${encodeURIComponent(this.search)}`;
      }
      try {
        const response = await axios.get(url, header);
        this.totalQuestions = response.data.count;
        this.Popupquestions = response.data.results.results.map((question) => ({
          ...question,
          selected: this.selectedItems.has(question.ID_D_Question),
        }));
        this.currentPage = page;

        if (response.data.results.cache_version !== cacheVersion) {
          this.updateCacheBusting(response.data.results.cache_version);
          await this.refreshData();
        }
      } catch (error) {
        console.error("Error fetching questions:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async refreshData() {
      const newCacheVersion = await this.initializeCacheBusting();
      const { itemsPerPage, page } = this.options;
      let url = `${base_url}${questions_urls.get_all}?page=${page}&page_size=${itemsPerPage}&cacheVersion=${newCacheVersion}`;
      if (this.search) {
        url += `&query=${encodeURIComponent(this.search)}`;
      }
      try {
        const response = await axios.get(url, header);
        this.totalQuestions = response.data.count;
        this.Popupquestions = response.data.results.results.map((question) => ({
          ...question,
          selected: this.selectedItems.has(question.ID_D_Question),
        }));
      } catch (error) {
        console.error("Error refreshing questions data:", error);
      }
    },

    resetSearch() {
      this.search = "";
      this.getQuestions(true);
    },

    updateSelectedItems(item) {
      if (item.selected) {
        this.selectedItems.add(item.ID_D_Question);
      } else {
        this.selectedItems.delete(item.ID_D_Question);
      }
    },

    openDeleteModuleDialog(module) {
      this.moduleToDelete = module;
      this.deleteModuleDialog = true;
    },

    async fetchUserDetails() {
      const userId = localStorage.getItem("id");
      if (userId) {
        try {
          const response = await this.getUserDetails(userId);
          this.userDetails = response.data;
        } catch (error) {
          console.error(
            "Erreur lors de la récupération des détails de l'utilisateur:",
            error
          );
          this.snackbarMessage =
            "Erreur lors de la vérification des droits utilisateur.";
          this.snackbarColor = "error";
          this.snackbar = true;
        }
      } else {
        this.snackbarMessage =
          "Impossible de vérifier les droits utilisateur. Veuillez vous reconnecter.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    async deleteModule() {
      const moduleId = this.$route.params.id;
      const url = `${base_url}${modules_urls.archive(moduleId)}`;

      await this.fetchUserDetails();

      if (!this.userDetails?.is_superuser) {
        this.snackbarMessage =
          "Vous n'avez pas les droits nécessaires pour supprimer ce module.";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      if (this.moduleToDelete) {
        const payload = {
          is_admin: true,
        };

        try {
          await axios.post(url, payload, header);
          this.snackbarMessage = `Le Module a été supprimé.`;
          this.snackbar = true;
          const newCacheVersion = new Date().getTime().toString();
          localStorage.setItem("cacheVersion", newCacheVersion);
          this.$router.push("/modules");
        } catch (error) {
          console.error("Erreur lors de la suppression du module:", error);
          this.snackbarMessage = `Erreur lors de la suppression du <strong>Module</strong>`;
          this.snackbarColor = "error";
          this.snackbar = true;
        }
        this.deleteModuleDialog = false;
      }
    },

    getUserDetails(id) {
      const url = `${base_url}${user_urls.get_details(id)}`;
      return axios.get(url, header);
    },

    getModuleDetails() {
      const moduleId = this.$route.params.id;
      const url = `${base_url}${modules_urls.get_details(moduleId)}`;
      const commentsUrl = `${base_url}${comments_urls.module_all}`;

      return axios
        .get(url, header)
        .then((response) => {
          this.module = {
            ...response.data,
          };
          if (this.module.TXT_LastEditedBy) {
            return this.getUserDetails(this.module.TXT_LastEditedBy);
          } else {
            return Promise.resolve(null);
          }
        })
        .then((userResponse) => {
          // Replace the user ID with username
          if (userResponse) {
            this.module.TXT_LastEditedBy = userResponse.data.username;
          }
          return axios.get(commentsUrl, header);
          // Fetch comments
        })
        .then((commentsResponse) => {
          this.module.comments = commentsResponse.data.filter(
            (comment) => comment.ID_D_Module === parseInt(moduleId)
          );
          const uniqueUserIds = [
            ...new Set(
              this.module.comments.map((comment) => comment.ID_NDAppUser)
            ),
          ];
          return Promise.all(
            uniqueUserIds.map((userId) => this.getUserDetails(userId))
          );
        })
        .then((userResponses) => {
          userResponses.forEach((userResponse) => {
            const username = userResponse.data.username;
            this.module.comments.forEach((comment) => {
              if (comment.ID_NDAppUser === userResponse.data.id) {
                comment.ID_NDAppUser = username;
              }
            });
          });
        })
        .catch((error) => {
          console.error("Error fetching module details:", error);
        });
    },

    openAddCommentDialog() {
      this.newComment = "";
      this.addCommentDialog = true;
    },

    openUpdateDialog(key) {
      this.dialogTitle = `Modifier ${this.keyTextMap[key]}`;
      this.fieldToUpdate = key;
      if (key === "SubThemes") {
        this.newFieldValue = this.module[key].map(
          (subtheme) => subtheme.ID_D_SubTheme__TXT_SubTheme
        );
      } else if (key === "Questions") {
        this.selectedItems = new Set(
          this.module.Questions.map((question) => question.ID_D_Question)
        );
        this.getQuestions();
      } else {
        this.newFieldValue = this.module[key];
      }
      this.dialog = true;
    },

    async confirmUpdate() {
      this.isUpdating = true;
      try {
        if (this.fieldToUpdate === "Questions") {
          this.newFieldValue = Array.from(this.selectedItems);
          await this.updateModule(this.fieldToUpdate, this.newFieldValue);
        } else if (
          this.fieldToUpdate === "TXT_Description" ||
          this.fieldToUpdate === "TXT_LearningObjectif" ||
          (this.newFieldValue !== undefined &&
            this.newFieldValue !== null &&
            this.newFieldValue !== "")
        ) {
          if (this.fieldToUpdate === "SubThemes") {
            const newSubThemes = this.SubThemes.filter((subtheme) =>
              this.newFieldValue.includes(subtheme.ID_D_SubTheme__TXT_SubTheme)
            );
            await this.updateModule(this.fieldToUpdate, newSubThemes);
          } else if (this.fieldToUpdate === "TXT_Comment") {
            await this.updateComment(this.currentCommentID, this.newFieldValue);
          } else {
            await this.updateModule(this.fieldToUpdate, this.newFieldValue);
          }
        }
      } catch (error) {
        console.error("Error during update:", error);
      } finally {
        this.isUpdating = false;
        this.dialog = false;
      }
    },

    updateComment(commentId, newComment) {
      const url = `${base_url}${comments_urls.module_details(commentId)}`;

      axios
        .put(url, { TXT_Comment: newComment }, header)
        .then(() => {
          const commentIndex = this.module.comments.findIndex(
            (comment) => comment.ID_FS_CommentsModule === commentId
          );
          this.module.comments[commentIndex].TXT_Comment = newComment;

          const newCacheVersion = new Date().getTime().toString();
          localStorage.setItem("cacheVersion", newCacheVersion);

          this.snackbarMessage = `Le commentaire a été mis à jour.`;
          this.snackbarColor = "success";
          this.snackbar = true;
        })
        .catch((error) => {
          console.error("Error updating comment:", error);

          this.snackbarMessage = `Une erreur s'est produite lors de la mise à jour du <strong>Commentaire</strong>`;
          this.snackbarColor = "error";
          this.snackbar = true;
        });
    },

    async updateQuestion(questionId, moduleId) {
      const url = `${base_url}${questions_urls.get_details(questionId)}`;
      try {
        const response = await axios.get(url, header);
        const questionData = response.data;

        questionData.Modules = moduleId;

        const userDetails = await this.getUserDetails(
          this.$store.state.auth.id
        );
        questionData.TXT_LastEditedBy = userDetails.data.id;

        questionData.DAT_LastEdited = new Date().toISOString();

        const updateResponse = await axios.put(url, questionData, header);

        if (updateResponse.data && updateResponse.data.cache_version) {
          this.updateCacheBusting(updateResponse.data.cache_version);
        } else {
          const currentVersion = await this.initializeCacheBusting();
          this.updateCacheBusting(String(parseInt(currentVersion) + 1));
        }
      } catch (error) {
        console.error(
          `Erreur lors de la mise à jour de la question ${questionId}:`,
          error
        );
        throw error;
      }
    },

    async updateModule(field, newValue) {
      const moduleId = this.$route.params.id;
      const url = `${base_url}${modules_urls.update(moduleId)}`;

      const updatedData = {
        TXT_Module: this.module.TXT_Module,
        TXT_Description: this.module.TXT_Description,
        TXT_LearningObjectif: this.module.TXT_LearningObjectif,
        DAT_Created: this.module.DAT_Created,
        [field]: newValue,
        DAT_LastEdited: new Date().toISOString(),
        TXT_CreatedBy: this.module.TXT_CreatedBy,
        TXT_LastEditedBy: this.$store.state.auth.id,
      };

      if (field === "Questions") {
        try {
          const currentQuestions = this.module.Questions.map(
            (question) => question.ID_D_Question
          );

          const questionsToAdd = newValue.filter(
            (id) => !currentQuestions.includes(id)
          );
          const questionsToRemove = currentQuestions.filter(
            (id) => !newValue.includes(id)
          );

          for (const questionId of questionsToAdd) {
            await this.updateQuestion(questionId, moduleId);
          }
          for (const questionId of questionsToRemove) {
            await this.updateQuestion(questionId, null);
          }

          this.module.Questions = newValue.map((id) => ({ ID_D_Question: id }));
        } catch (error) {
          console.error("Erreur lors de la mise à jour des questions:", error);
          this.snackbarMessage = `Une erreur s'est produite lors de la mise à jour des questions`;
          this.snackbarColor = "error";
          this.snackbar = true;
          return;
        }
      }

      try {
        const response = await axios.put(url, updatedData, header);
        this.module = response.data;

        const newCacheVersion = new Date().getTime().toString();
        localStorage.setItem("cacheVersion", newCacheVersion);

        this.getModuleDetails();

        this.snackbarMessage = `Le champ <strong>${this.keyTextMap[field]}</strong> a été mis à jour`;
        this.snackbarColor = "success";
        this.snackbar = true;
      } catch (error) {
        console.error(error);
        this.snackbarMessage = `Une erreur s'est produite lors de la mise à jour du champ <strong>${this.keyTextMap[field]}</strong>`;
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    formatDate(date) {
      const dateObject = new Date(date);
      const options = { day: "2-digit", month: "2-digit", year: "numeric" };
      const formattedDate = dateObject.toLocaleDateString("fr-FR", options);
      return formattedDate;
    },

    openCommentUpdateDialog(comment) {
      this.dialogTitle = `Modifier le commentaire de ${this.formatDate(
        comment.DAT_Created
      )}`;
      this.fieldToUpdate = "TXT_Comment";
      this.newFieldValue = comment.TXT_Comment;
      this.dialog = true;
      this.currentCommentID = comment.ID_FS_CommentsModule;
    },

    addComment() {
      const url = `${base_url}${comments_urls.module_all}`;

      const commentData = {
        ID_NDAppUser: this.$store.state.auth.id,
        DAT_Created: new Date().toISOString(),
        TXT_Comment: this.newComment,
        ID_D_Module: this.$route.params.id,
      };

      axios
        .post(url, commentData, header)
        .then(() => {
          this.getModuleDetails(); // Fetch subtheme details again to update the comments list

          this.snackbarMessage = `Votre commentaire a été ajouté avec succès.`;
          this.snackbar = true;

          const newCacheVersion = new Date().getTime().toString();
          localStorage.setItem("cacheVersion", newCacheVersion);

          this.addCommentDialog = false;
        })
        .catch((error) => {
          console.error("Error adding comment:", error);

          this.snackbarMessage = `Une erreur s'est produite lors de l'ajout du commentaire`;
          this.snackbarColor = "error";
          this.snackbar = true;
        });
    },

    openDeleteDialog(comment) {
      this.commentToDelete = comment;
      this.deleteDialog = true;
    },

    deleteComment() {
      if (this.commentToDelete) {
        const url = `${base_url}${comments_urls.delete_module(
          this.commentToDelete.ID_FS_CommentsModule
        )}`;

        axios
          .delete(url, header)
          .then(() => {
            this.getModuleDetails();

            const newCacheVersion = new Date().getTime().toString();
            localStorage.setItem("cacheVersion", newCacheVersion);

            this.snackbarMessage = `Votre commentaire a été supprimé.`;
            this.snackbar = true;

            this.deleteDialog = false;
          })
          .catch((error) => {
            console.error("Error deleting comment:", error);

            this.snackbarMessage = `Erreur lors de la suppression du commentaire`;
            this.snackbarColor = "error";
            this.snackbar = true;
          });
      }
    },
    updateOptions(newOptions) {
      this.options = newOptions;
    },

    openUnassignQuestionDialog(question) {
      this.questionToUnassign = question;
      this.unassignQuestionDialog = true;
    },

    async unassignQuestionFromModule() {
      if (!this.questionToUnassign) return;

      const questionId = this.questionToUnassign.ID_D_Question;
      this.isUnassigning = true;
      try {
        await unassignQuestionFromModuleUseCase(questionId);

        this.module.Questions = this.module.Questions.filter(
          (question) => question.ID_D_Question !== questionId
        );

        this.snackbarMessage = `La question a été désaffectée du module.`;
        this.snackbarColor = "success";
      } catch (error) {
        console.error("Erreur lors de la désaffectation:", error);
        this.snackbarMessage = `Une erreur s'est produite lors de la <strong>désaffectation</strong> de la question`;
        this.snackbarColor = "error";
      } finally {
        this.isUnassigning = false;
        this.snackbar = true;
        this.unassignQuestionDialog = false;
        this.questionToUnassign = null;
      }
    },

    openQuestionDeleteDialog(question){
      this.questionToDelete = question;
      this.deleteQuestionDialog = true;
    },

    async deleteQuestion(){
      if (!this.questionToDelete) return;

      const questionId = this.questionToDelete.ID_D_Question;
      this.isDeletingQuestion = true;
      try {
        await deleteQuestionUseCase(questionId);

        this.module.Questions = this.module.Questions.filter(
          (question) => question.ID_D_Question !== questionId
        );

        this.snackbarMessage = `La question a été supprimé du module.`;
        this.snackbarColor = "success";
      } catch (error) {
        console.error("Erreur lors de la suppression:", error);
        this.snackbarMessage = `Une erreur s'est produite lors de la <strong>suppression</strong> de la question`;
        this.snackbarColor = "error";
      } finally {
        this.isDeletingQuestion = false;
        this.snackbar = true;
        this.deleteQuestionDialog = false;
        this.questionToDelete = null;
      }
    }
  },

  computed: {
    reversedComments() {
      return [...(this.module.comments || [])].reverse();
    },
    formattedQuestions() {
      if (!this.search) {
        return this.Questions.map((question) => ({
          title:
            question.TXT_Question.length > 75
              ? question.TXT_Question.substring(0, 75) + "..."
              : question.TXT_Question,
          value: question.ID_D_Question,
        }));
      }
      const searchTerms = this.search
        .toLowerCase()
        .split(" ")
        .filter((word) => word.length > 0);
      return this.Questions.filter((question) => {
        const questionLowerCase = question.TXT_Question.toLowerCase();
        return searchTerms.every((term) => questionLowerCase.includes(term));
      }).map((question) => ({
        title:
          question.TXT_Question.length > 75
            ? question.TXT_Question.substring(0, 75) + "..."
            : question.TXT_Question,
        value: question.ID_D_Question,
      }));
    },
  },

  created() {
    this.getModuleDetails();
    this.getQuestions();
  },

  mounted() {
    document.title = "Module - Détails";
  },
};
</script>

<style lang="scss">
.details.module .data-table .v-table .v-data-table__td {
  width: 100%;
}


.details.module .related-data-table .v-data-table__td:last-child {
  width: 120px;
  white-space: nowrap;
}

.question-actions {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;

  &__unassign {
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
